import Explainer from '../blocks';

import styles from './CriticalRiskPolicy.module.css';

const EXPLAINER_WIDTH = 1280;
const EXPLAINER_HEIGHT = 696;

const CriticalRiskPolicy = () => {
  return (
    <Explainer
      width={EXPLAINER_WIDTH}
      height={EXPLAINER_HEIGHT}
      className={styles.root}
    >
      <rect width="1280" height="695.893" rx="10" fill="#007C68" />
      <g
        fontFamily="var(--font-family-body)"
        fontSize="11.2"
        letterSpacing="0.005em"
      >
        <rect
          x="46"
          y="215"
          width="250.4"
          height="40"
          rx="6.4"
          fill="white"
          fillOpacity="0.1"
        />
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M64.0703 230.611L60.8125 233.869V236.131L64.0703 239.389H66.332L69.5898 236.131V233.869L66.332 230.611H64.0703ZM61.6125 235.799V234.201L64.4017 231.411L66.0006 231.411L68.7898 234.201V235.799L66.0006 238.589L64.4017 238.589L61.6125 235.799ZM63.2099 234.571H67.1924V235.451H63.2099V234.571Z"
            fill="white"
          />
        </g>
        <text fill="white" x="83.5996" y="238.248">
          CVSS Score
        </text>
        <rect
          x="46"
          y="264.6"
          width="250.4"
          height="40"
          rx="6.4"
          fill="white"
          fillOpacity="0.1"
        />
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M60.8125 283.469L64.0703 280.211L66.3319 280.211L69.5898 283.469V285.731L66.3319 288.989L64.0703 288.989L60.8125 285.731V283.469ZM61.6125 283.801V285.399L64.4017 288.189L66.0006 288.189L68.7898 285.399V283.801L66.0006 281.011L64.4017 281.011L61.6125 283.801Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M64.8379 285.151L64.7128 283.711L64.7125 282.322L64.8206 282.214L65.5966 282.214L65.7048 282.322L65.7051 283.704L65.5793 285.151L65.4739 285.256L64.9433 285.256L64.8379 285.151ZM64.7508 286.826L64.6426 286.718V285.855L64.7508 285.746L65.6493 285.746L65.7575 285.855V286.718L65.6493 286.826L64.7508 286.826Z"
            fill="white"
          />
        </g>
        <text fill="white" x="83.5996" y="287.848">
          CVE Severity
        </text>
        <rect
          x="46"
          y="314.2"
          width="250.4"
          height="40"
          rx="6.4"
          fill="white"
          fillOpacity="0.1"
        />
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M68.4531 329.358H62.7601L61.7058 330.371V334.489H62.5058V330.712L63.082 330.158H68.1311L68.7073 330.712V335.014L66.4109 337.577H65.4471V338.377H66.7659L69.5073 335.322V330.371L68.4531 329.358ZM61.1379 335.154L62.5962 336.612L64.0544 335.154L64.6201 335.72L63.1619 337.178L64.62 338.636L64.0543 339.202L62.5962 337.744L61.1381 339.202L60.5724 338.636L62.0305 337.178L60.5723 335.72L61.1379 335.154Z"
            fill="white"
          />
        </g>
        <text fill="white" x="83.5996" y="337.448">
          Type
        </text>
        <g opacity="0.9">
          <rect
            x="46"
            y="363.8"
            width="250.4"
            height="40"
            rx="6.4"
            fill="white"
            fillOpacity="0.1"
          />
          <g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M63.8024 380.733L65.7834 378.752H67.23L69.211 380.733V382.18L67.23 384.161H65.7834L65.1186 383.496L63.7742 384.84L65.2051 386.271L64.6395 386.837L63.2085 385.406L61.9914 386.623V387.064L63.2093 388.282L62.6437 388.848L61.1914 387.395V386.292L64.5529 382.93L63.8024 382.18V380.733ZM64.6024 381.065V381.848L66.1148 383.361H66.8986L68.411 381.848V381.065L66.8986 379.552L66.1148 379.552L64.6024 381.065Z"
              fill="white"
            />
          </g>
          <text fill="white" x="83.5996" y="387.048">
            API key
          </text>
        </g>
        <rect
          x="46"
          y="413.4"
          width="250.4"
          height="40"
          rx="6.4"
          fill="white"
          fillOpacity="0.1"
        />
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M70.0965 429.722L66.2891 434.378H65.0146L63.8719 432.595H63.2487L60.915 435.208L60.3184 434.675L62.8906 431.795H64.3093L65.452 433.578H65.9099L69.4772 429.216L70.0965 429.722Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M70.4257 437.584H59.9785V436.784H70.4257V437.584Z"
            fill="white"
          />
        </g>
        <text fill="white" x="83.5996" y="436.648">
          Quality score
        </text>
        <rect
          x="46"
          y="463"
          width="250.4"
          height="40"
          rx="6.4"
          fill="white"
          fillOpacity="0.1"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M68.2633 479L61.341 479L60.3066 480.034V485.966L61.341 487L68.2633 487L69.2977 485.966V480.034L68.2633 479ZM61.1066 480.366L61.6723 479.8L67.932 479.8L68.4977 480.366V485.634L67.932 486.2L61.6723 486.2L61.1066 485.634V480.366Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M63.2004 482.2H62.4004V481.4H63.2004V482.2Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M63.5411 478.2L63.5402 480.415L62.7402 480.415L62.7411 478.2L63.5411 478.2Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M67.6642 478.2L67.6633 480.415L66.8633 480.415L66.8642 478.2L67.6642 478.2Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M63.2004 483.8H62.4004V483H63.2004V483.8Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M63.2004 485.4H62.4004V484.6H63.2004V485.4Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M64.8 482.2H64V481.4H64.8V482.2Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M64.8 483.8H64V483H64.8V483.8Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M64.8 485.4H64V484.6H64.8V485.4Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M66.3996 482.2H65.5996V481.4H66.3996V482.2Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M66.3996 483.8H65.5996V483H66.3996V483.8Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M66.3996 485.4H65.5996V484.6H66.3996V485.4Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M68.0012 482.2H67.2012V481.4H68.0012V482.2Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M68.0012 483.8H67.2012V483H68.0012V483.8Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M68.0012 485.4H67.2012V484.6H68.0012V485.4Z"
          fill="white"
        />
        <text fill="white" x="83.5996" y="486.248">
          Package age
        </text>
        <g opacity="0.8">
          <rect
            x="46"
            y="512.6"
            width="250.4"
            height="40"
            rx="6.4"
            fill="white"
            fillOpacity="0.1"
          />
          <g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M69.8011 531.23L66.6321 530.962L65.3994 527.846H64.9882L63.7556 530.962L60.6062 531.228L60.4492 531.661L62.8667 533.839L62.1312 537.081L62.4893 537.354L65.1938 535.617L67.8702 537.336L68.2533 537.067L67.521 533.839L69.9528 531.649L69.8011 531.23ZM68.4094 531.935L66.0566 531.737L65.1938 529.556L64.3311 531.737L61.9783 531.935L63.7728 533.551L63.2408 535.896L65.1938 534.642L67.1469 535.896L66.6149 533.551L68.4094 531.935Z"
              fill="white"
            />
          </g>
          <text fill="white" x="83.5996" y="535.848">
            Package contributions
          </text>
        </g>
        <g opacity="0.6">
          <rect
            x="46"
            y="562.2"
            width="250.4"
            height="40"
            rx="6.4"
            fill="white"
            fillOpacity="0.1"
          />
          <g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M64.0703 577.811L60.8125 581.069V583.331L64.0703 586.589H66.332L69.5898 583.331V581.069L66.332 577.811H64.0703ZM61.6125 582.999V581.401L64.4017 578.611L66.0006 578.611L68.7898 581.401V582.999L66.0006 585.789L64.4017 585.789L61.6125 582.999ZM63.2099 581.771H67.1924V582.651H63.2099V581.771Z"
              fill="white"
            />
          </g>
          <text fill="white" x="83.5996" y="585.448">
            Quarantine
          </text>
        </g>
        <g opacity="0.4">
          <rect
            x="46"
            y="611.8"
            width="250.4"
            height="40"
            rx="6.4"
            fill="white"
            fillOpacity="0.1"
          />
          <g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M66.8537 626.946H63.5473L62.8712 628.725H61.1445V629.525H69.2564V628.725H67.5298L66.8537 626.946ZM66.674 628.725L66.3018 627.746L64.0991 627.746L63.727 628.725H66.674ZM67.6356 630.291L67.1664 635.055L66.3672 635.854H64.0062L63.2079 635.056L62.7656 630.293L61.9688 630.365L62.4372 635.417L63.6748 636.654H66.6986L67.9354 635.418L68.432 630.367L67.6356 630.291ZM64.8004 634.748V630.562H65.6004V634.748H64.8004Z"
              fill="white"
            />
          </g>
          <text fill="white" x="83.5996" y="635.048">
            Delete
          </text>
        </g>
        <g opacity="0.3">
          <rect
            x="46"
            y="661.4"
            width="250.4"
            height="40"
            rx="6.4"
            fill="white"
            fillOpacity="0.1"
          />
          <g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M69.8011 680.03L66.6321 679.763L65.3994 676.646H64.9882L63.7556 679.763L60.6062 680.028L60.4492 680.462L62.8667 682.639L62.1312 685.881L62.4893 686.154L65.1938 684.417L67.8702 686.136L68.2533 685.867L67.521 682.639L69.9528 680.449L69.8011 680.03ZM68.4094 680.735L66.0566 680.537L65.1938 678.356L64.3311 680.537L61.9783 680.735L63.7728 682.352L63.2408 684.697L65.1938 683.442L67.1469 684.697L66.6149 682.352L68.4094 680.735Z"
              fill="white"
            />
          </g>
          <text fill="white" x="83.5996" y="684.648">
            Last contributed to
          </text>
        </g>
      </g>
      <g opacity="0.3" filter="url(#filter1_f_3912_7795)">
        <path
          d="M478.788 -246.228C567.841 86.1209 370.61 427.735 38.2603 516.788C-294.089 605.84 -635.703 408.609 -724.756 76.26C-813.808 -256.089 -616.578 -597.703 -284.228 -686.756C48.1211 -775.809 389.735 -578.578 478.788 -246.228Z"
          fill="#57C7A4"
        />
      </g>
      <g opacity="0.3" filter="url(#filter2_f_3912_7795)">
        <path
          d="M1523.79 -523.228C1612.84 -190.879 1415.61 150.735 1083.26 239.788C750.911 328.84 409.297 131.609 320.244 -200.74C231.192 -533.089 428.422 -874.703 760.772 -963.756C1093.12 -1052.81 1434.74 -855.578 1523.79 -523.228Z"
          fill="#00A084"
        />
      </g>
      <rect
        width="824"
        height="805"
        transform="translate(228 103.107)"
        fill="white"
      />
      <text
        fill="#092F45"
        fontFamily="Replica LL"
        fontSize="20"
        letterSpacing="0em"
      >
        <tspan x="264" y="148.107">
          Critical Risk Policy
        </tspan>
      </text>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M899.354 125.107H783.535V125.111L780 128.646V165.568V165.575H780.007L783.535 169.104V169.107H899.354V169.104L899.354 169.104L902.882 165.575H902.89V128.646H902.889L899.354 125.111L899.354 125.111V125.107Z"
        fill="#2A6FE1"
      />
      <g stroke="white" strokeOpacity="0.5" fill="none">
        <path d="M804.676 143.446L807.83 146.507V147.708L804.676 150.769" />
        <path d="M809.424 143.446L812.578 146.507V147.708L809.424 150.769" />
        <path d="M814.172 143.446L817.326 146.507V147.708L814.172 150.769" />
      </g>
      <text
        fill="white"
        fontFamily="Replica LL"
        fontSize="16"
        letterSpacing="0.02em"
      >
        <tspan x="827.103" y="152.707">
          Publish
        </tspan>
      </text>
      <text
        fill="#8497A2"
        fontFamily="MD System"
        fontSize="14"
        letterSpacing="0.005em"
      >
        <tspan x="949" y="151.167">
          Test policy
        </tspan>
      </text>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M936.97 142.544H931.324V141.544H937.385L939.178 143.337V147.398H938.178V143.751L936.97 142.544Z"
        fill="#8497A2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M938.006 148.327H939.351L941.937 145.741L941.23 145.034L939.176 147.327H938.184L936.127 145.034L935.42 145.741L938.006 148.327Z"
        fill="#8497A2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M933.03 150.671H938.676V151.671H932.615L930.822 149.878V145.817H931.822V149.464L933.03 150.671Z"
        fill="#8497A2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M931.994 144.888H930.649L928.063 147.474L928.77 148.181L930.829 145.888H931.809L933.873 148.181L934.58 147.474L931.994 144.888Z"
        fill="#8497A2"
      />
      <rect
        x="485.5"
        y="250.596"
        width="310"
        height="66"
        rx="7.5"
        fill="#FAFCFD"
        stroke="#E6EAEC"
      />
      <rect
        x="485.5"
        y="398.596"
        width="310"
        height="66"
        rx="7.5"
        fill="#FAFCFD"
        stroke="#E6EAEC"
      />
      <text
        fill="#8497A2"
        fontFamily="Replica Mono LL"
        fontSize="9"
        letterSpacing="0.005em"
      >
        <tspan x="509" y="426.246">
          Vulnerabitiy{' '}
        </tspan>
      </text>
      <text
        fill="#092F45"
        fontFamily="MD System"
        fontSize="14"
        letterSpacing="0.005em"
      >
        <tspan x="509" y="443.156">
          CVE Severity - Critical
        </tspan>
      </text>
      <path
        d="M763.022 425.073L764.975 425.076L770.071 430.167L770.072 432.16L764.98 437.258L763.02 437.258L757.923 432.155L757.923 430.186L763.022 425.073Z"
        fill="#76CCAD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M763.92 433.31L766.676 429.773L766.304 429.483L763.689 432.839L763.367 432.839L761.765 431.029L761.412 431.341L763.155 433.31L763.92 433.31Z"
        fill="white"
        stroke="white"
        strokeWidth="0.147344"
      />
      <rect x="485" y="215.096" width="81" height="23" rx="4" fill="#EAF1FC" />
      <text
        fill="#092F45"
        fontFamily="Replica Mono LL"
        fontSize="10"
        letterSpacing="0.04em"
      >
        <tspan x="493.182" y="230.096">
          Conditions
        </tspan>
      </text>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M635.999 575.133L640.084 579.729L641.807 579.729L645.875 575.132L645.126 574.47L641.443 578.632L641.443 537.096L640.443 537.096L640.443 578.628L636.747 574.469L635.999 575.133Z"
        fill="#2A6FE1"
      />
      <rect x="485" y="596.096" width="62" height="23" rx="4" fill="#EAF1FC" />
      <text
        fill="#092F45"
        fontFamily="Replica Mono LL"
        fontSize="10"
        letterSpacing="0.04em"
      >
        <tspan x="493.438" y="611.096">
          Actions
        </tspan>
      </text>
      <text
        fill="#8497A2"
        fontFamily="Replica Mono LL"
        fontSize="9"
        letterSpacing="0.005em"
      >
        <tspan x="509" y="278.246">
          Vulnerabitiy{' '}
        </tspan>
      </text>
      <text
        fill="#092F45"
        fontFamily="MD System"
        fontSize="14"
        letterSpacing="0.005em"
      >
        <tspan x="509" y="295.156">
          CVSS Score &#62; 6
        </tspan>
      </text>
      <path
        d="M763.022 277.073L764.975 277.076L770.071 282.167L770.072 284.16L764.98 289.258L763.02 289.258L757.923 284.155L757.923 282.186L763.022 277.073Z"
        fill="#76CCAD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M763.92 285.31L766.676 281.773L766.304 281.483L763.689 284.839L763.367 284.839L761.765 283.029L761.412 283.341L763.155 285.31L763.92 285.31Z"
        fill="white"
        stroke="white"
        strokeWidth="0.147344"
      />
      <rect
        x="629.5"
        y="489.596"
        width="23"
        height="23"
        rx="5.5"
        fill="#2A6FE1"
        stroke="#EAF1FC"
      />
      <rect x="636" y="500.596" width="10" height="1" fill="white" />
      <rect
        x="640.5"
        y="506.096"
        width="10"
        height="1"
        transform="rotate(-90 640.5 506.096)"
        fill="white"
      />
      <rect
        x="597.5"
        y="341.596"
        width="86"
        height="32"
        rx="7.5"
        fill="white"
      />
      <rect
        x="597.5"
        y="341.596"
        width="86"
        height="32"
        rx="7.5"
        stroke="#E7EAEC"
        fill="none"
      />
      <rect x="602" y="346.096" width="37" height="23" rx="4" fill="#0A1B2A" />
      <text
        fill="white"
        fontFamily="Replica Mono LL"
        fontSize="11"
        letterSpacing="0.005em"
      >
        <tspan x="610" y="361.446">
          AND
        </tspan>
      </text>
      <text
        fill="#092F45"
        fillOpacity="0.65"
        fontFamily="Replica Mono LL"
        fontSize="11"
        letterSpacing="0.005em"
      >
        <tspan x="657" y="361.446">
          OR
        </tspan>
      </text>
      <rect
        x="485.5"
        y="631.596"
        width="310"
        height="66"
        rx="7.5"
        fill="#FAFCFD"
        stroke="#E6EAEC"
      />
      <text
        fill="#8497A2"
        fontFamily="Replica Mono LL"
        fontSize="9"
        letterSpacing="0.005em"
      >
        <tspan x="509" y="659.246">
          Packages
        </tspan>
      </text>
      <text
        fill="#092F45"
        fontFamily="MD System"
        fontSize="14"
        letterSpacing="0.005em"
      >
        <tspan x="509" y="676.156">
          Quarantine
        </tspan>
      </text>
      <path
        d="M763.022 658.073L764.975 658.076L770.071 663.167L770.072 665.16L764.98 670.258L763.02 670.258L757.923 665.155L757.923 663.186L763.022 658.073Z"
        fill="#76CCAD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M763.92 666.31L766.676 662.773L766.304 662.483L763.689 665.839L763.367 665.839L761.765 664.029L761.412 664.341L763.155 666.31L763.92 666.31Z"
        fill="white"
        stroke="white"
        strokeWidth="0.147344"
      />
      <g fontFamily="Replica Mono LL" fontSize="8.4" letterSpacing="-0.02em">
        <rect x="949" y="309" width="331" height="424" rx="7" fill="#0A1B2A" />
        <text fill="#5F7886">
          <tspan x="967.672" y="332.24">
            1&#10;
          </tspan>
          <tspan x="967.672" y="347.64">
            2&#10;
          </tspan>
          <tspan x="967.672" y="363.04">
            3&#10;
          </tspan>
          <tspan x="967.672" y="378.44">
            4&#10;
          </tspan>
          <tspan x="967.672" y="393.84">
            5&#10;
          </tspan>
          <tspan x="967.672" y="409.24">
            6&#10;
          </tspan>
          <tspan x="967.672" y="424.64">
            7&#10;
          </tspan>
          <tspan x="967.672" y="440.04">
            8&#10;
          </tspan>
          <tspan x="967.672" y="455.44">
            9&#10;
          </tspan>
          <tspan x="962.713" y="470.84">
            10&#10;
          </tspan>
          <tspan x="962.713" y="486.24">
            11&#10;
          </tspan>
          <tspan x="962.713" y="501.64">
            12&#10;
          </tspan>
          <tspan x="962.713" y="517.04">
            13&#10;
          </tspan>
          <tspan x="962.713" y="532.44">
            14&#10;
          </tspan>
          <tspan x="962.713" y="547.84">
            15&#10;
          </tspan>
          <tspan x="962.713" y="563.24">
            16&#10;
          </tspan>
          <tspan x="962.713" y="578.64">
            17&#10;
          </tspan>
          <tspan x="962.713" y="594.04">
            18&#10;
          </tspan>
          <tspan x="962.713" y="609.44">
            19&#10;
          </tspan>
          <tspan x="962.713" y="624.84">
            20&#10;
          </tspan>
          <tspan x="962.713" y="640.24">
            21&#10;
          </tspan>
          <tspan x="962.713" y="655.64">
            22&#10;
          </tspan>
          <tspan x="962.713" y="671.04">
            23&#10;
          </tspan>
          <tspan x="962.713" y="686.44">
            24&#10;
          </tspan>
          <tspan x="962.713" y="701.84">
            25&#10;
          </tspan>
          <tspan x="962.713" y="717.24">
            26&#10;
          </tspan>
        </text>
        <text fill="#E6EAEC">
          <tspan x="1027.11" y="332.24">
            {' '}
            policy&#x2028;
          </tspan>
          <tspan x="992.4" y="347.64">
            &#x2028;
          </tspan>
          <tspan x="1022.15" y="363.04">
            {' '}
            rego.v1&#x2028;
          </tspan>
          <tspan x="992.4" y="378.44">
            &#x2028;
          </tspan>
          <tspan x="1126.29" y="393.84">
            &#x2028;
          </tspan>
          <tspan x="992.4" y="409.24">
            max_cvss :={' '}
          </tspan>
          <tspan x="1051.91" y="409.24">
            &#x2028;
          </tspan>
          <tspan x="992.4" y="424.64">
            &#x2028;
          </tspan>
          <tspan x="1304.81" y="440.04">
            &#x2028;
          </tspan>
          <tspan x="992.4" y="455.44">
            cve_allowlist :={' '}
          </tspan>
          <tspan x="1161" y="455.44">
            &#x2028;
          </tspan>
          <tspan x="992.4" y="470.84">
            &#x2028;
          </tspan>
          <tspan x="1027.11" y="486.24">
            {' '}
            match :={' '}
          </tspan>
          <tspan x="1096.54" y="486.24">
            &#x2028;
          </tspan>
          <tspan x="992.4" y="501.64">
            &#x2028;
          </tspan>
          <tspan x="992.4" y="517.04">
            match{' '}
          </tspan>
          <tspan x="1032.07" y="517.04"></tspan>
          <tspan x="1037.03" y="517.04">
            &#x2028;
          </tspan>
          <tspan x="992.4" y="532.44"></tspan>
          <tspan x="1017.2" y="532.44">
            {' '}
            target{' '}
          </tspan>
          <tspan x="1066.78" y="532.44">
            {' '}
            input.v0.security_scan&#x2028;
          </tspan>
          <tspan x="992.4" y="547.84"></tspan>
          <tspan x="1017.2" y="547.84">
            {' '}
            vulnerability{' '}
          </tspan>
          <tspan x="1101.5" y="547.84">
            {' '}
            target.Vulnerabilities&#x2028;
          </tspan>
          <tspan x="992.4" y="563.24">
            &#x2028;
          </tspan>
          <tspan x="1225.47" y="578.64">
            &#x2028;
          </tspan>
          <tspan x="992.4" y="594.04"></tspan>
          <tspan x="1012.24" y="594.04">
            {' '}
            vulnerability.VulnerabilityID{' '}
          </tspan>
          <tspan x="1175.88" y="594.04">
            {' '}
            cve_allowlist&#x2028;
          </tspan>
          <tspan x="992.4" y="609.44">
            &#x2028;
          </tspan>
          <tspan x="992.4" y="624.84"></tspan>
          <tspan x="1017.2" y="624.84">
            {' '}
            cvss{' '}
          </tspan>
          <tspan x="1056.87" y="624.84">
            {' '}
            vulnerability.CVSS&#x2028;
          </tspan>
          <tspan x="992.4" y="640.24">
            &#x2028;
          </tspan>
          <tspan x="1324.65" y="655.64">
            &#x2028;
          </tspan>
          <tspan x="992.4" y="671.04">
            {' '}
            cvss.V3Score &#62; max_cvss&#x2028;
          </tspan>
        </text>
        <text fill="#915EFF" x="992.4" y="332.24">
          package
        </text>
        <text fill="#915EFF" x="992.4" y="363.04">
          import
        </text>
        <text fill="#915EFF" x="992.4" y="486.24">
          default
        </text>
        <text fill="#915EFF" x="1076.7" y="486.24">
          false
        </text>
        <text fill="#915EFF" x="1022.15" y="517.04">
          if
        </text>
        <text fill="#915EFF" x="997.359" y="532.44">
          some
        </text>
        <text fill="#915EFF" x="997.359" y="547.84">
          some
        </text>
        <text fill="#915EFF" x="1056.87" y="532.44">
          in
        </text>
        <text fill="#915EFF" x="1091.58" y="547.84">
          in
        </text>
        <text fill="#915EFF" x="997.359" y="594.04">
          not
        </text>
        <text fill="#915EFF" x="1165.96" y="594.04">
          in
        </text>
        <text fill="#915EFF" x="997.359" y="624.84">
          some
        </text>
        <text fill="#915EFF" x="1046.95" y="624.84">
          in
        </text>
        <text fill="#FFD482" x="997.4" y="655.64">
          # check if this CVSS score is higher than the maximum allowed value
        </text>
        <text fill="#FFD482" x="997.4" y="578.64">
          # check if this CVE has been explicitly allowed
        </text>
        <text fill="#FFD482" x="992.4" y="393.84">
          # maximum allowed CVSS score
        </text>
        <text fill="#FFD482" x="992.4" y="440.04">
          # array containing IDs of CVEs that have been explicitly allowed
        </text>
        <text fill="#85DABB" x="1051.91" y="409.24">
          6
        </text>
        <text fill="#B73B55" x="992.4" y="686.44">
          &#125;
        </text>
        <text fill="#B73B55" x="1037.03" y="517.04">
          &#123;
        </text>
        <text fill="#B73B55" x="1076.7" y="455.44">
          [
        </text>
        <text fill="#B73B55" x="1161" y="455.44">
          ]
        </text>
        <text fill="#76CCAD" x="1081.66" y="455.44">
          &#34;CVE-2023-32681&#34;
        </text>
        <rect
          x="1206"
          y="312"
          width="81"
          height="421"
          fill="url(#paint0_linear_3912_7795)"
        />
        <rect
          x="1280"
          y="614.107"
          width="81"
          height="331"
          transform="rotate(90 1280 614.107)"
          fill="url(#paint1_linear_3912_7795)"
        />
      </g>
      <line
        x1="141.75"
        y1="186"
        x2="141.75"
        y2="215"
        stroke="#57C7A4"
        strokeWidth="1.5"
        strokeDasharray="2 2"
      />
      <line
        x1="640.75"
        y1="74"
        x2="640.75"
        y2="103"
        stroke="#57C7A4"
        strokeWidth="1.5"
      />
      <line
        x1="1128.75"
        y1="280"
        x2="1128.75"
        y2="309"
        stroke="#57C7A4"
        strokeWidth="1.5"
        strokeDasharray="2 2"
      />
      <text
        fill="white"
        fontFamily="Replica Mono LL"
        fontSize="12"
        letterSpacing="0.005em"
      >
        <tspan x="85.8105" y="157.2">
          20+ conditions{' '}
        </tspan>
        <tspan x="104.301" y="171.2">
          &#38; actions
        </tspan>
      </text>
      <text
        fill="white"
        fontFamily="Replica Mono LL"
        fontSize="16"
        letterSpacing="0.005em"
      >
        <tspan x="537.161" y="55.1">
          Custom policy builder
        </tspan>
      </text>
      <text
        fill="white"
        fontFamily="Replica Mono LL"
        fontSize="12"
        letterSpacing="0.005em"
      >
        <tspan x="1080.53" y="262.2">
          Build in code
        </tspan>
      </text>
      <rect
        x="1279.5"
        y="700"
        width="1281"
        height="99.9999"
        transform="rotate(-180 1279.5 700)"
        fill="url(#paint2_linear_3912_7795)"
      />
      <defs>
        <filter
          id="filter1_f_3912_7795"
          x="-946.139"
          y="-908.139"
          width="1646.31"
          height="1646.31"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="100"
            result="effect1_foregroundBlur_3912_7795"
          />
        </filter>
        <filter
          id="filter2_f_3912_7795"
          x="98.8613"
          y="-1185.14"
          width="1646.31"
          height="1646.31"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="100"
            result="effect1_foregroundBlur_3912_7795"
          />
        </filter>
        <linearGradient
          id="paint0_linear_3912_7795"
          x1="1206"
          y1="522.5"
          x2="1287"
          y2="522.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0A1B2A" stopOpacity="0" />
          <stop offset="1" stopColor="#0A1B2A" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3912_7795"
          x1="1280"
          y1="779.607"
          x2="1361"
          y2="779.607"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0A1B2A" stopOpacity="0" />
          <stop offset="1" stopColor="#0A1B2A" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3912_7795"
          x1="1920"
          y1="700"
          x2="1920"
          y2="800"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#005E4F" stopOpacity="0.1" />
          <stop offset="1" stopColor="#005E4F" stopOpacity="0" />
        </linearGradient>
      </defs>
    </Explainer>
  );
};

export default CriticalRiskPolicy;
